<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    -->
    <p class="title">联系我们</p> 
    <p class="email_wx" v-if="footerInfo.companyname">
      <span>公司名称：{{footerInfo.companyname}}</span>
    </p>
    <p class="address_tel_fax" v-if="footerInfo.address">
      <span>地址：{{footerInfo.address}}</span>
    
    </p>
   
    <p class="email_wx" v-if="footerInfo.phone">
      电话：{{footerInfo.phone}}
    </p>
    <p class="email_wx" v-if="footerInfo.email">
      电子邮件：{{footerInfo.email}}
    </p>
    <!-- <p class="email_wx"  v-if="footerInfo.companycontact">
      TEL： {{footerInfo.companycontact}}
    </p> -->
    <p class="copy" > &copy; {{footerInfo.companyname}} {{footerInfo.icpcode}} </p>
    <p class="copy" > 网站建设：沧州市东昊智胜信息技术有限公司</p>

 
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      footerInfo:{},
    
    }
  },
  watch:{
    isFooter(newval,oldVal){
      
      newval?this.footerInfo=newval:this.footerInfo=oldVal;
     
       
  },
  },
  computed:{
    isFooter(){
      return this.$store.state.footerInfo
    }
  },
  created(){
    this.footerInfo=this.$store.state.footerInfo
  }
};
</script>
<style scoped>
#footer {
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
  padding-top: 20px;
  width: 100%;
  height: 100%;
  color: #fff;

  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #fff;
  font-size: 16px;
  margin: 10px 0;
}
.email_wx {
  color: #fff;
  /* color: #d3d3d3; */
  font-size: 16px;
}
.copy {
  color: #fff;
  font-size: 16px;
  /* margin: 20px 0 10px; */
}
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue